import Vue from 'vue';
import Vconsole from 'vconsole';
import { Lazyload } from 'vant';

import App from './App.vue';
import router from './router';
import store from './store';
import bsUtils from '@/utils';
import installBsFilters from '@/filters';
import installBsDirectives from '@/directives';
import { isProduct } from '@/utils/flag';
import 'vant/lib/index.css';

// 注入全局方法
Vue.use(bsUtils);

// 引入图片懒加载
Vue.use(Lazyload);

// 注入全局过滤器与自定义指令
installBsFilters(Vue);
installBsDirectives(Vue);

// 给strig对象增加一个length2方法，将1个中文字符按2个长度计算来获取字符串长度。
// String.prototype.length2 = function() {
//   var cArr = this.match(/[^\x00-\xff]/gi);
//   return this.length + (cArr == null ? 0 : cArr.length); // eslint-disable-line
// };

Vue.config.productionTip = false;

if (!isProduct() && process.env.VUE_APP_ENV === 'sit') {
  new Vconsole();
}

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
